import React from 'react';
import qs from 'qs';
import ExpiredView from './ExpiredView';
import { useSecureQueryParameters } from 'hooks/useQueryParameters';

const Expired: React.FC = props => {
  const allowedQueryParameters = useSecureQueryParameters();

  const restartPath = `${process.env.REACT_BASENAME ||
    ''}/prequal/phone-lookup${qs.stringify(allowedQueryParameters, {
    addQueryPrefix: true,
  })}`;

  return <ExpiredView {...props} restartPath={restartPath} />;
};

export default Expired;
